import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, isConflict } from "@/lib/api";
import { ConflictDialog } from "@/components/ConflictDialog";

const FIELDS = [["name", "Company name"], ["phone", "Phone"], ["email", "Email"], ["gstin", "GSTIN"]];

export const CompanySettings = ({ isAdmin }) => {
  const [c, setC] = useState(null);
  const [conflict, setConflict] = useState(false);
  useEffect(() => { api.get("/company").then((r) => setC(r.data)); }, []);
  if (!c) return null;
  const reload = () => api.get("/company").then((r) => { setC(r.data); setConflict(false); toast.success("Latest company details loaded"); });
  const set = (k) => (e) => setC({ ...c, [k]: e.target.value });
  const save = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.put("/company", { ...c, gst_percent: Number(c.gst_percent) || 0, expected_rev: c.rev || 0 });
      setC(data);
      toast.success("Company & PO details saved");
    } catch (err) { if (isConflict(err)) setConflict(true); else toast.error(errMsg(err)); }
  };
  return (
    <form onSubmit={save} className="panel mt-8 p-5 space-y-4" data-testid="company-settings-form">
      <div>
        <h2 className="text-base md:text-lg font-semibold">Company & Purchase Order format</h2>
        <p className="text-xs text-muted-foreground">Printed on every purchase / manufacturing order.</p>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([k, label]) => (
          <div key={k} className="space-y-1.5"><Label>{label}</Label>
            <Input disabled={!isAdmin} value={c[k] || ""} onChange={set(k)} data-testid={`company-${k}-input`} /></div>
        ))}
        <div className="space-y-1.5"><Label>GST % on PO (0 = hide)</Label>
          <Input type="number" step="1" min="0" max="100" disabled={!isAdmin} value={c.gst_percent} onChange={set("gst_percent")} data-testid="company-gst-input" /></div>
      </div>
      <div className="space-y-1.5"><Label>Address</Label>
        <Textarea rows={2} disabled={!isAdmin} value={c.address || ""} onChange={set("address")} data-testid="company-address-input" /></div>
      <div className="space-y-1.5"><Label>Terms & conditions (one per line)</Label>
        <Textarea rows={7} disabled={!isAdmin} value={c.po_terms || ""} onChange={set("po_terms")} data-testid="company-terms-input" /></div>
      {isAdmin && <div className="flex justify-end"><Button type="submit" data-testid="company-save-btn">Save details</Button></div>}
      <ConflictDialog open={conflict} what="company detail" onClose={() => setConflict(false)} onReload={reload} />
    </form>
  );
};
